
import { BoxMaintenanceEditPage } from "./edit.box";
import { CloudMaintenanceEditPage } from "./edit.cloud";
import { DemoMaintenanceEditPage } from "./edit.demo";

import { mixin } from "@cems-eco/core/src/utils/platform";
import environment from "@/config";

export default class MaintenanceEdit extends mixin(environment.nexus, {
  box: BoxMaintenanceEditPage,
  cloud: CloudMaintenanceEditPage,
  demo: DemoMaintenanceEditPage,
}) {
  [key: string]: any;
}
